import Image from 'next/image';
import type { FC } from 'react';
import { useEffect, useRef } from 'react';
import { Box } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import type { IRoadMapBox } from '@/Module/HomePage/Component/HomePageRoadMap/data';
import { IconPinBlue, IconPinGreen, IconPinRed } from '@/Module/Icon';
interface IProps extends IRoadMapBox {
  isActive: boolean;
  setIndexList: (index: number, isActive: boolean) => void;
}
const RoadMapCard: FC<IProps> = ({
  isActive,
  setIndexList,
  title,
  description,
  id
}) => {
  const deviceType = useDeviceType();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) return () => {};
    const observer = new IntersectionObserver(([entire]) => {
      if (id === 5) {
        setIndexList(id, entire.isIntersecting);
        setIndexList(id + 1, entire.isIntersecting);
      }
      setIndexList(id, entire.isIntersecting);
    }, {
      threshold: deviceType === DeviceType.MOBILE ? 0.25 : 1
    });
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref.current]);
  return <div className="my-5 flex items-start " ref={ref} data-sentry-component="RoadMapCard" data-sentry-source-file="RoadMapCard.tsx">
      <div className="-mt-4 ml-4 flex flex-col items-center gap-2 md:gap-0  ">
        <div className="transition-all delay-1000 duration-700">
          {/* eslint-disable-next-line no-nested-ternary */}
          {isActive ? <IconPinGreen /> : id % 2 !== 0 ? <IconPinBlue /> : <IconPinRed />}
        </div>

        {id !== 5 && <div className=" h-screen max-h-36 w-1 rounded-3xl bg-blackThree sm:max-h-24">
            <div className={` rounded-3xl bg-black transition-all delay-200 duration-1000 ${isActive ? 'h-full' : 'h-0'}`} />
          </div>}
      </div>

      <Box color={isActive ? 'lime' : 'white'} as="div" className="text-BlueSix  flex  w-full max-w-[800px] flex-col items-start justify-start border-[6px] p-4 pt-0 text-lg transition-all delay-200 duration-1000" data-sentry-element="Box" data-sentry-source-file="RoadMapCard.tsx">
        <Image width={64} height={64} className="-mt-8 w-full max-w-[64px] text-center" alt="zak" src={`${FILE_BROWSER_URL}/img/zak.webp`} data-sentry-element="Image" data-sentry-source-file="RoadMapCard.tsx" />
        <h4 className=" font-black md:mb-2">{title}</h4>
        <p className="leading-[25px] "> {description}</p>
      </Box>
    </div>;
};
export default RoadMapCard;